module.exports = __webpack_public_path__ + "img/app-start.7ac4353c.png";